 import { EVENT_NOTIFICATION_SHOW,
     EVENT_NOTIFICATION_HIDE, 
     EventNotificationActionTypes} from '../../actions/common/EventNotificationActions';

import { EVENT_NOTIFICATION_TYPE } from '../../helpers/EventNotificationType';
import { Hideable } from '../../models/common/ViewSettings';

export interface EventNotificationState extends Hideable {
    messageType: EVENT_NOTIFICATION_TYPE
    message: string
}

 const initialState: EventNotificationState =  {
     messageType: EVENT_NOTIFICATION_TYPE.ajaxSuccess,
     message: '',
     isVisible: false
};

export function EventNotificationReducer( state = initialState, action: EventNotificationActionTypes ): EventNotificationState {
    switch(action.type ) {
        case EVENT_NOTIFICATION_SHOW:
            return {
                messageType: action.messageType,
                message: action.message,
                isVisible: true
            };
        case EVENT_NOTIFICATION_HIDE:
            return {
                ...state,
                isVisible: false
            };
        default:
            return state;
    }
}